import React, { Component } from 'react';
import firebase from 'firebase';
import withAuthorization from '../Session/withAuthorization';
import { compose } from 'recompose';
import '../css/main.css';

class ChatUser extends Component {

    constructor(props){
        super(props);
        this.state = {
            show : false,
            error : ''
        }
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    handleSubmit(event){
        event.preventDefault();
        var self = this
        this.setState({
            error :  false
        })
        var message = this.message.value;
        if(message === ''){
            this.setState({
                error :  true
            })
        }
        else{
            var uid = firebase.auth().currentUser.uid
            firebase.database().ref('/users/vendors/').child(uid).child('details').once('value', function(snap){
                var res = snap.val();
                firebase.database().ref('/users/admin/messages').push({From :res.name , Msg : message});
                self.setState({
                    show: true
                })
            })
        }
        this.formMessage.reset();
    }

    render(){
        return(
            <div className="m-t-100 display_home" style={{backgroundColor : 'white'}}> 
                <form ref={(el) => this.formMessage = el} id="chat_user" onSubmit = {this.handleSubmit} style={{flexDirection : 'column'}}>
                    <label>Message : </label> <br/> 
                    <textarea type="string" name="message" style={{height: '300px' , width : '300px' , textAlign : 'left'}}ref={node => (this.message = node)} required className="limiter"/>
                    {this.state.show ? <p>Message Sent</p> : null}
                    <button onClick={() =>this.handleSubmit} className="container-login100">
                    Send Message</button>
                </form>
            </div>
        )
    }

}


const authCondition = (authUser) => !!authUser;

export default compose(withAuthorization(authCondition))(ChatUser);